const borderStyleData = ['solid', 'dashed', 'dotted'];

import { Select } from 'shared/components/selects/Select';

type SelectBorderStyleProps = {
  value: string;
  onChange: (value: string) => void;
};

export const SelectBorderStyle = (props: SelectBorderStyleProps) => {
  const { value, onChange } = props;

  return <Select data={borderStyleData} value={value} onChange={value => value && onChange(value)} />;
};
